(function () {
  'use strict';

  const src = window.__themeSlideshowSrc;
  if (!src) return;

  const els = document.querySelectorAll('slideshow-component');
  if (!els.length) return;

  let done = false;

  function load() {
    if (done) return;
    done = true;
    obs.disconnect();
    import(src);
  }

  const obs = new IntersectionObserver(
    function (entries) {
      for (let i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          load();
          break;
        }
      }
    },
    { rootMargin: '500px' }
  );

  els.forEach(function (el) {
    obs.observe(el);
  });

  // Fallback for non-scrolling sessions
  setTimeout(load, 5000);
})();